import { _ as r } from "../internals/export.js";
import { g as t } from "../internals/global.js";
import { g as n } from "../internals/get-built-in.js";
import { f as a } from "../internals/function-uncurry-this.js";
import { f as i } from "../internals/function-call.js";
import { f as o } from "../internals/fails.js";
import { t as s } from "../internals/to-string.js";
import { v as e } from "../internals/validate-arguments-length.js";
import { b as l } from "../internals/base64-map.js";
var f = l.itoc,
  m = n("btoa"),
  c = a("".charAt),
  u = a("".charCodeAt),
  g = !!m && !o(function () {
    m();
  }),
  p = !!m && o(function () {
    return "bnVsbA==" !== m(null);
  }),
  b = !!m && 1 !== m.length;
r({
  global: !0,
  bind: !0,
  enumerable: !0,
  forced: g || p || b
}, {
  btoa: function btoa(r) {
    if (e(arguments.length, 1), g || p || b) return i(m, t, s(r));
    for (var a, o, l = s(r), h = "", j = 0, d = f; c(l, j) || (d = "=", j % 1);) {
      if ((o = u(l, j += 3 / 4)) > 255) throw new (n("DOMException"))("The string contains characters outside of the Latin1 range", "InvalidCharacterError");
      h += c(d, 63 & (a = a << 8 | o) >> 8 - j % 1 * 8);
    }
    return h;
  }
});